var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('perseu-card',{attrs:{"title":"Mudanças no sistema"}},[_c('v-flex',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm._f("formatDate")(new Date())))]),_c('p',[_vm._v("- Primeira versão do sistema com funcionalidades requisitadas")]),_c('p',[_vm._v("- Cadastros requisitados")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }